export default "__VITE_ASSET__B_D9kg4Z__"